import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { SPACE } from "@xo-union/constant-key-codes";
var handleKeyDown = function handleKeyDown(evt) {
  if (evt.keyCode === SPACE) {
    evt.preventDefault();

    /* Simulate click on the input, which in turn forces the onChange callback to be called */
    evt.currentTarget.click();
  }
};
var InteractiveElement = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("div", _extends({
    tabIndex: "0",
    ref: ref,
    role: props.role,
    onKeyDown: handleKeyDown
  }, props));
});
InteractiveElement.propTypes = {
  role: PropTypes.string
};
export default InteractiveElement;